<template lang="pug">
  v-menu(offset-y eager)
    template(v-slot:activator="{ on }")
      k-button(
        v-on="on"
        @click.prevent=""
        x-small
        text
        icon
      ).mr-0
        k-icon(color="brand-dark-blue") ellipsis
    k-card-text(small).white
      slot
</template>

<script>
export default {
}
</script>
